import script from "./ImportedOrdersView.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportedOrdersView.vue?vue&type=script&setup=true&lang=js"

import "./ImportedOrdersView.vue?vue&type=style&index=0&id=1ccf5bdf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ccf5bdf"]])

export default __exports__